export const environment = {
  production: false,
  API_ENDPOINT: 'https://devapi.unaflormx.com/v1/',
  API_KEY_MAP: 'AIzaSyA242kkoJeptD6_CcqgL-FkbfsHR5LPirw'
};
